import tariffRecommenderImage from '../../../assets/svg/tariffs-illustration.svg';
import welcomeModalIllustration from '../../../assets/svg/welcome-modal-illustration.svg';
import type { Images } from '../ThemeTypes';

const images: Images = {
  tariffRecommender: {
    mainCardLogo: tariffRecommenderImage,
    width: '100%',
    '${min.sm}': {
      width: '200px',
    },
  },
  welcomeModal: {
    headerBackground: 'linear-gradient(0deg, #2648B2, #473EAC 100%)',
    illustration: welcomeModalIllustration,
  },
};

export default images;
